<template>
  <CRow>
    <CCol sm="12" md="12" lg="12">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CCol>
    <CCol sm="12" md="12" class="mb-5">
      <h2 class="">
        <b class="welcomeUser">{{ $t('home.infoUser.welcome') }}</b>
        <span class="welcomeUserName">{{ extrairPrimeiroNome(auth.user.name) }}</span>
      </h2>
    </CCol>
    <CCol sm="12" md="4" lg="3" class="d-flex flex-column align-items-center justify-content-center">
      <ImageProfile size="xl5" sizeFontAvatar="60px" />
      <div v-if="!isSendit && isOrganizationApproved === false" class="mt-2 d-flex align-items-center justify-content-center gap-4">
        <CIcon name="infoCircle" size="custom-size" class="text-warning mr-2" :height="20" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
        <router-link :to="{ name: 'manage-balance-plans' }" tag="a" class="text-decoration text-warning font-lg">{{
          $t('home.account-in-review')
        }}</router-link>
      </div>
      <div v-if="isSendit && isOrganizationApproved === false" class="mt-4 d-flex align-items-center justify-content-center gap-4">
        <CButton
          v-if="canManagePlans"
          class="px-4 py-2 font-weight-bold ctaInfoUserPrimary d-flex align-items-center gap-8"
          :disabled="isLoadingApproveAccount"
          @click="approveAccount"
        >
          <CSpinner v-if="isLoadingApproveAccount" color="custom-color" style="width: 1rem; height: 1rem" />
          <span>
            {{ $t('home.approve-account') }}
          </span>
        </CButton>
      </div>
    </CCol>
    <CCol style="margin-left: 50px; min-height: 160px" sm="12" md="3" lg="4" class="d-flex flex-column justify-content-around">
      <div>
        <span class="plan-badge">{{ $t(`general.plans.${auth.session.organization.planName.toLowerCase()}`) }} {{ $t('home.infoUser.plan') }}</span>
        <div class="fullUserName mt-2 d-flex gap-8 align-items-center">
          <span class="max-w-240 overflow-auto">{{ auth.session.organization.name }}</span>
          <CIcon
            v-if="isOrganizationApproved !== undefined"
            name="cilCheckCircle"
            size="custom-size"
            :class="isOrganizationApproved ? 'text-primary' : 'text-gray-500'"
            :height="20"
            v-c-tooltip="{ content: isOrganizationApproved ? $t('home.account-approved') : $t('home.account-in-review'), placement: 'top' }"
          />
        </div>
        <router-link :to="{ name: 'mainOrganization' }" class="edit-profile-arpoone">{{ $t('home.infoUser.edit-profile') }}</router-link>
        <div v-if="isSendit && auth.session.salesManager" class="font-weight-bolder my-3">
          {{ $t('home.infoUser.accountManager') }}:
          <span class="font-weight-normal ml-1">{{ auth.session.salesManager.name || '' }}</span>
        </div>
      </div>
      <div class="">
        <CButton v-if="canManagePlans" class="px-4 py-2 font-weight-bold ctaInfoUserPrimary" @click="$router.push({ name: 'manage-balance-plans' })">
          {{ $t('home.infoUser.manage-plans') }}
        </CButton>
        <!-- <router-link v-if="auth.session.organization.planName != 'Corporate'" :to="{ name: 'manage-balance-plans' }" class="ctaInfoUserPrimary">
          {{ $t('home.infoUser.manage-plans') }}
        </router-link> -->
      </div>
    </CCol>
    <CCol style="margin-left: 20px; min-height: 160px" sm="12" md="4" lg="4" class="d-flex flex-column justify-content-around">
      <div>
        <div class="accountBalanceTitle mt-2">
          {{ $t('home.infoUser.accountBalance') }}
        </div>
        <div class="accountBalanceSubTitle">A summary of your the total amount of your emails and sms available.</div>
      </div>
      <div v-if="canManageBalance">
        <CButton
          v-if="isVisibleManageBalance"
          class="px-4 py-2 font-weight-bold ctaInfoUserPrimary"
          @click="$router.push({ name: 'manage-balance-indirect-distribution' })"
        >
          {{ $t('home.campaignSumary.manage-balance') }}
        </CButton>
        <!-- <router-link v-if="isVisibleManageBalance" class="ctaInfoUserPrimary" :to="{ name: 'manage-balance-indirect-distribution' }">
          {{ $t('home.campaignSumary.manage-balance') }}
        </router-link> -->
        <CButton v-if="isVisibleManagePacks" class="px-4 py-2 font-weight-bold ctaInfoUserPrimary" @click="$router.push({ name: 'manage-balance' })">
          {{ $t('home.campaignSumary.manage-balance') }}
        </CButton>
        <!-- <router-link v-if="isVisibleManagePacks" class="ctaInfoUserPrimary" :to="{ name: 'manage-balance' }">
          {{ $t('home.campaignSumary.manage-balance') }}
        </router-link> -->
      </div>
    </CCol>
  </CRow>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ImageProfile from '../../../components/ImageProfile.vue'
import { featuresEnum, checkFeatures } from '@/utils/featureUtils'
import services from '@/services.js'
import { getErrorMessage } from '@/utils/errorHandling.js'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  name: 'InfoUser',
  props: {
    isVisibleManageBalance: {
      type: Boolean,
      default: () => false,
    },
    isVisibleManagePacks: {
      type: Boolean,
      default: () => false,
    },
    isOrganizationApproved: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoadingApproveAccount: false,
      messages: [],
    }
  },
  methods: {
    extrairPrimeiroNome(value) {
      let primeiroNome = value.split(' ')[0] || ''
      return primeiroNome
    },
    approveAccount() {
      this.isLoadingApproveAccount = true
      services
        .approveOrganization(this.$route.params.organizationId)
        .then(() => {
          this.messages = [
            {
              status: 'success',
              text: this.$t(`home.account-approved-success`),
            },
          ]
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => {
          this.isLoadingApproveAccount = false
        })
    },
  },
  components: {
    ImageProfile,
    MenssageAlert,
  },
  computed: {
    ...mapState(['auth']),
    ...mapGetters({
      hasSessionPermission: 'auth/hasSessionPermission',
      isSendit: 'auth/isSendit',
    }),
    canManagePlans() {
      return (
        this.auth.session.organization.planName != 'Corporate' &&
        this.hasSessionPermission('Balance_Plan_Buy') &&
        checkFeatures(featuresEnum.SUBSCRIPTION_PLANS)
      )
    },
    canManageBalance() {
      return this.hasSessionPermission('Balance_Addon_Buy')
    },
  },
}
</script>

<style lang="scss" scoped>
.gap-4 {
  gap: 4px;
}
.gap-8 {
  gap: 8px;
}
.max-w-240 {
  max-width: 240px;
}
</style>

<style>
.welcomeUser {
  color: #868e96;
  font-weight: 600;
}

.welcomeUserName {
  margin-left: 10px;
}

.plan-badge {
  background-color: #e8e0f0;
  color: #403266;
  font-size: 14px;
  border-radius: 4px;
  padding: 5px 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.fullUserName {
  font-size: 24px;
  font-weight: 600;
}

.accountBalanceTitle {
  font-size: 26px;
  font-weight: 600;
}

.accountBalanceSubTitle {
  font-size: 18px;
  color: #868e96;
  max-width: 90%;
}

.edit-profile-arpoone {
  color: #8b65b3;
  font-size: 17px;
}

.edit-profile-arpoone:hover {
  text-decoration: underline !important;
  color: #8b65b3;
}

.ctaInfoUserPrimary {
  border: 1px solid #8b65b3 !important;
  color: #8b65b3;
  background-color: #fff;
}

.ctaInfoUserPrimary:active {
  color: #403266;
  border: 1px solid #403266;
}

.ctaInfoUserPrimary:hover {
  color: #403266;
  border: 1px solid #403266;
}
</style>
